var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('app-layout',{scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('app-header')]},proxy:true},{key:"footer",fn:function(){return [_c('app-footer')]},proxy:true}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }